import { useLazyQuery } from "@apollo/client";
import { gql } from "generated-graphql";
import { ManifestEditInput } from "generated-graphql/graphql";
import { useCallback } from "react";

const VALIDATE_MANIFEST_EDIT_INPUT = gql(`
  query ValidateManifestEditInput($manifestId: ID!, $data: ManifestEditInput!) {
    manifestEditInputValidator(manifestId: $manifestId, input: $data) {
      ...issue
    }
  }
`);

export function useManifestInputValidation(manifestId: string) {
  const [query] = useLazyQuery(VALIDATE_MANIFEST_EDIT_INPUT, {
    fetchPolicy: "no-cache",
  });

  return useCallback(
    async (input: ManifestEditInput) => {
      const { data, previousData } = await query({
        variables: {
          manifestId,
          data: input,
        },
      });

      return data
        ? data?.manifestEditInputValidator
        : previousData?.manifestEditInputValidator ?? [];
    },
    [query, manifestId]
  );
}